$.get("https://cdn.jsdelivr.net/bxslider/4.1.1/jquery.bxslider.min.js", function(data){
	eval(data);
	// slider設定
	$('#js-bxslider').bxSlider({
		speed: 1500,
		prevText: '前へ',
		nextText: '次へ',
		pager: false,
		infiniteLoop: false,
		hideControlOnEnd: true
	});
	// カートマネージャー再設定
	if(typeof CartManager != 'undefined'){
		cart = new CartManager();
		cart.initialize();
	}
	
	// レコメンド共通処理
	registRecommendEvent($("#new-footer-recommend"));
});